<template>
  <div>
    <div class="fix-wrapper">
      <breadcrumb
        :crumbs="[
          $t('menu.agentSettlements'),
          $t('action.importCheck') + '：' + settleObj.clientName,
        ]"
      ></breadcrumb>
      <div class="container">
        <div class="pd20">
          <div class="import">
            <ul class="orange">
              <li class="explain">
                {{ $t("newImportExpressSettlement.excelTitle") }}
              </li>
              <li class="explain">
                {{ $t("newImport.excelTemplate") }}:
                <a :href="excelTemplate" target="_blank">{{
                  $t("newImport.clickDownload")
                }}</a>
              </li>
              <li class="explain">
                {{ $t("newImport.beCareful") }}：1、{{
                  $t("newImport.beCarefulMustFill")
                }}
              </li>
            </ul>
          </div>
          <div class="center">
            <el-upload
              ref="upload"
              :action="url"
              :headers="fileHeaders"
              :show-file-list="false"
              :before-upload="beforeAvatarUpload"
              :on-success="importResult"
              accept=".xls, .xlsx"
            >
              <el-button
                type="success"
                size="small"
                style="width: 100px"
                :loading="importLoading"
                >{{ $t("action.import") }}</el-button
              >
            </el-upload>
          </div>
          <div v-if="results.length != 0">
            <div class="mgb10">
              <span class="mgl15">{{ $t("newImport.results") }}：</span>
              <span class="orange">{{
                $t("newImportExpressSettlement.resultExplain")
              }}</span>
            </div>
            <div class="mgb15">
              <vxe-table
                :data="results"
                size="mini"
                resizable
                round
                auto-resize
                highlight-hover-row
                :scroll-y="{ enabled: false }"
              >
                <vxe-table-column
                  field="tracking"
                  :title="$t('delivery.importTracking')"
                  min-width="100"
                >
                  <template v-slot="{ row }">
                    <span :class="row.delivery == null ? 'red' : ''">
                      {{ row.tracking }}
                    </span>
                    <div v-if="row.delivery == null" class="red font10">
                      系统中匹配不到,请核对
                    </div>
                    <div
                      v-if="repeatTrackings.includes(row.tracking)"
                      class="orange font10"
                    >
                      跟踪号重复
                    </div>
                  </template>
                </vxe-table-column>
                <vxe-table-column
                  field="serialNo"
                  :title="$t('delivery.serialNo')"
                  min-width="100"
                >
                  <template v-slot="{ row }">
                    <span v-if="row.delivery != null">
                      {{ row.delivery.serialNo }}
                      <div class="font10">
                        {{ row.delivery.tracking }}
                      </div>
                    </span>
                  </template>
                </vxe-table-column>
                <vxe-table-column
                  field="weight"
                  :title="$t('delivery.weight')"
                  min-width="100"
                >
                  <template v-slot="{ row }">
                    <span v-if="row.delivery != null">
                      {{ row.delivery.weight || "无" }}
                    </span>
                    <div class="font10">
                      <span v-if="row.delivery == null">
                        {{ $t("delivery.importWeight") }}:
                        {{ row.importWeight }}
                      </span>
                      <span v-if="row.delivery != null">
                        <span
                          v-if="row.delivery.weight != row.importWeight"
                          :class="
                            row.delivery.weight != row.importWeight ? 'red' : ''
                          "
                        >
                          {{ $t("delivery.importWeight") }}:
                          {{ row.importWeight }}
                        </span>
                      </span>
                    </div>
                  </template>
                </vxe-table-column>
                <vxe-table-column
                  field="deliverCost"
                  :title="$t('delivery.deliverCost')"
                  min-width="100"
                >
                  <template v-slot="{ row }">
                    <span
                      v-if="
                        row.delivery != null && row.delivery.deliverCost != null
                      "
                      >{{ row.delivery.deliverCost | currency }}</span
                    >
                    <div class="font10">
                      <span v-if="row.delivery == null">
                        {{ $t("delivery.importCost") }}:
                        {{ row.importCost | currency }}
                      </span>
                      <span
                        v-if="row.delivery != null"
                        :class="
                          row.delivery.deliverCost != row.importCost
                            ? 'red'
                            : null
                        "
                        >{{ $t("delivery.importCost") }}:
                        {{ row.importCost | currency }}
                      </span>
                    </div>
                  </template>
                </vxe-table-column>
                <vxe-table-column
                  field="explain"
                  :title="$t('delivery.costExplain')"
                  min-width="100"
                >
                  <template v-slot="{ row }">
                    <span
                      v-if="
                        row.delivery != null && row.delivery.explain != null
                      "
                      >{{ row.delivery.explain }}</span
                    >
                    <div class="font10">
                      <span v-if="row.delivery == null"
                        >{{ $t("delivery.importCostExplain") }}:
                        <raw-html-limit-number
                          :content="row.importCostExplain"
                          :number="10"
                        />
                      </span>
                      <span
                        v-if="row.delivery != null"
                        :class="
                          row.delivery.explain != row.importCostExplain
                            ? 'red'
                            : ''
                        "
                        >{{ $t("delivery.importCostExplain") }}:
                        <raw-html-limit-number
                          :content="row.importCostExplain"
                          :number="10"
                        />
                      </span>
                    </div>
                  </template>
                </vxe-table-column>
                <vxe-table-column
                  field="express"
                  :title="$t('delivery.express')"
                  min-width="100"
                >
                  <template v-slot="{ row }">
                    <span
                      v-if="row.delivery != null"
                      :class="
                        settleObj.clientName != row.delivery.express
                          ? 'red'
                          : ''
                      "
                    >
                      {{ row.delivery.express }}
                    </span>
                  </template>
                </vxe-table-column>
                <vxe-table-column
                  field="settlementId"
                  :title="$t('delivery.settlementId')"
                  min-width="80"
                >
                  <template v-slot="{ row }">
                    <span
                      v-if="
                        row.delivery != null &&
                        row.delivery.settlementId != null
                      "
                      class="red"
                      >{{ $t("boolean.true") }}</span
                    >
                  </template>
                </vxe-table-column>
                <vxe-table-column
                  field="action"
                  :title="$t('text.action')"
                  width="50"
                >
                  <template v-slot="{ row, rowIndex }">
                    <el-button
                      type="text"
                      size="mini"
                      @click="remove(row, rowIndex)"
                    >
                      {{ $t("text.remove") }}
                    </el-button>
                  </template>
                </vxe-table-column>
              </vxe-table>
            </div>
            <fieldset>
              <el-form
                ref="settleObjForm"
                :model="settleObj"
                label-width="80px"
              >
                <el-row>
                  <el-col :span="6">
                    <el-form-item
                      :label="$t('settlement.title')"
                      :prop="'title'"
                      :rules="[
                        {
                          required: true,
                          validator: validateTitle,
                          trigger: 'blur',
                        },
                      ]"
                    >
                      <el-input size="small" v-model.trim="settleObj.title" />
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item
                      :label="$t('settlement.amount')"
                      :prop="'amount'"
                      :rules="[
                        {
                          required: true,
                          message: $t('rules.required', [
                            $t('settlement.amount'),
                          ]),
                          trigger: 'blur',
                        },
                      ]"
                    >
                      <el-input size="small" v-model.trim="settleObj.amount" />
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item :label="$t('settlement.totalQuantity')">
                      {{ settleObj.deliveryQuantity }}
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </fieldset>
          </div>
        </div>

        <div class="form-footer">
          <el-button
            v-if="results.length != 0"
            type="primary"
            plain
            :loading="saveDoing"
            size="medium"
            @click="saveSubmit"
            >{{ $t("text.submit") }}</el-button
          >
          <back-button />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { page } from "@/utils/mixins.js";
import { coreEndpoint, fileserverEndpoint } from "@/settings";
import Util from "@/utils";
import BackButton from "@/components/BackButton";
import RawHtmlLimitNumber from "@/components/RawHtmlLimitNumber";

import Cookies from "@/utils/cookies.js";
import Courier from "@/api/courier.js";
import DeliverySettlement from "@/api/deliverySettlement.js";

export default {
  mixins: [page],
  components: { BackButton, RawHtmlLimitNumber },
  data() {
    var validateTitle = (rule, value, callback) => {
      const self = this;
      if (value == null) {
        callback(
          new Error(this.$t("rules.required", [this.$t("settlement.title")]))
        );
        return;
      }
      DeliverySettlement.findByTitle({ title: value }).then(function (res) {
        if (res.data.code === 200) {
          callback(
            new Error(self.$t("rules.exist", [self.$t("settlement.title")]))
          );
          return;
        } else {
          callback();
        }
      });
    };
    return {
      excelTemplate:
        fileserverEndpoint +
        "/public/excelTemplates/jy_deliverImportCheck.xlsx",
      // 导入
      url: coreEndpoint + "/excels/import-courier-verify/agent",
      fileHeaders: {
        type: "web",
        token: Cookies.getToken(),
      },
      results: [],
      importLoading: false,
      courierTenants: [],
      validateTitle: validateTitle,
      settleObj: {
        title: null,
        amount: null,
        deliveryQuantity: null,
        settleType: "agent",
        deliveries: [],
        clientId: null,
        clientName: null,
      },
      saveDoing: false,
      repeatTrackings: [],
    };
  },

  computed: {},
  created() {
    const self = this;
    this.results = [];

    Courier.findCourierTenantByTenantId().then(function (res) {
      if (res.status === 200) {
        self.courierTenants = res.data;
        const selectedCourierTenant = self.courierTenants.find(
          (c) => c.courierId === parseInt(self.$route.params.id)
        );
        self.settleObj.clientName = selectedCourierTenant.courier.name;
        self.settleObj.clientId = selectedCourierTenant.courier.id;
        self.settleObj.title =
          self.settleObj.clientName + Util.serialNoSimple();
      } else {
        self.sysError();
      }
    });
  },
  methods: {
    // 导入
    beforeAvatarUpload(file) {
      this.importLoading = true;
      return true;
    },
    importResult(res, file) {
      const self = this;
      this.importLoading = false;
      self.results = res.datas;
      this.computeAmount();
      this.judgeRepeat();
    },
    computeAmount() {
      const self = this;
      self.settleObj.amount = 0;
      self.settleObj.deliveryQuantity = self.results.length;
      for (const item of self.results) {
        self.settleObj.amount =
          parseInt(self.settleObj.amount) + parseInt(item.importCost || 0);
      }
    },
    judgeRepeat() {
      let trackings = this.results.map((r) => r.tracking);
      this.repeatTrackings = [];
      let filterRepeatTrackings = [];
      for (let t of trackings) {
        if (filterRepeatTrackings.indexOf(t) !== -1) {
          this.repeatTrackings.push(t);
        } else {
          filterRepeatTrackings.push(t);
        }
      }
    },
    remove(row, rowIndex) {
      this.results.splice(rowIndex, 1);
      this.computeAmount();
      this.judgeRepeat();
    },
    saveSubmit() {
      const self = this;
      self.$refs.settleObjForm.validate((valid) => {
        if (valid) {
          if (self.results.length === 0) {
            this.$message({
              message: self.$t("prompt.atLeastOneData"),
              type: "warning",
            });
            return;
          }
          if (self.repeatTrackings.length !== 0) {
            this.$message({
              message: "存在重复的跟踪号",
              type: "warning",
            });
            return;
          }

          for (const r of self.results) {
            if (r.delivery != null && r.delivery.settlementId != null) {
              this.$message({
                message: self.$t("prompt.existSettlementedDelivery"),
                type: "warning",
              });
              return;
            }
            if (
              r.delivery != null &&
              r.delivery.courierId !== self.settleObj.clientId
            ) {
              this.$message({
                message: self.$t("prompt.existCourierDiffDelivery"),
                type: "warning",
              });
              return;
            }

            if (r.importCost == null || r.importCost === "") {
              this.$message({
                message: self.$t("prompt.exitCostIsNull"),
                type: "warning",
              });
              return;
            }
          }
          self.settleObj.deliveries = [];
          for (const item of self.results) {
            if (item.delivery != null) {
              const obj = {
                id: item.delivery.id,
                courierCost: item.importCost,
                courierWeight: item.importWeight,
                explain: item.importCostExplain,
              };
              self.settleObj.deliveries.push(obj);
            }
          }
          if (self.settleObj.deliveries.length === 0) {
            this.$message({
              message: self.$t("prompt.atLeastOneValidData"),
              type: "warning",
            });
            return;
          }
          self.saveDoing = true;
          DeliverySettlement.create(self.settleObj).then(function (res) {
            self.saveDoing = false;
            self.$message({
              message: self.$t("prompt.addSuccess"),
              type: "success",
            });
            self.$router.push({ name: "fnReportsDeliverSettlementsAgents" });
          });
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
</style>